<template>
  <div class="p-fa-home">
    <Navigation> </Navigation>
    <Container>
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <div class="title-header">
              Selamat Datang di pencarian agen asuransi
              <b> Sequis </b>
            </div>
          </div>
          <div class="row">
            <div class="title-content">
              Kami tahu sangat sulit mencari agen asuransi yang sesuai harapan 
              Anda, oleh karena itu kami akan membantu Anda menemukannya
              semaksimal mungkin
            </div>
          </div>
          <div v-if="outside.activeLink == 'true'" class="row">
            <div class="title-content">
              <button type="button" class="base-button" @click="search()">
                MULAI CARI AGEN UNTUK SAYA
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <img
            alt="banner"
            src="../../../../assets/images/svg/landing-fa.svg"
            class="img-responsive"
            style="width: 100%"
          />
        </div>
      </div>
    </Container>
    <div class="c-footer">
      <div class="col-sm-12" style="text-align: center; padding: 0 10%;">
        <div>PT Asuransi Jiwa Sequis Life berizin dan diawasi oleh Otoritas Jasa Keuangan</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '../../components/Navigation';
import Container from '../../components/Container';

export default {
  name: 'FaHome',
  components: {
    Navigation,
    Container,
  },
  props: ['outside', 'env_ssr'],
  methods: {
    search() {
      this.$router.push({
        name: 'FaNew',
        params: { id: 1 },
        query: {
          utm_campaign: this.$route.query.utm_campaign,
          utm_medium: this.$route.query.utm_medium,
          utm_source: this.$route.query.utm_source,
        },
      });
    },
  },
};
</script>
